import BerryClubLanding from './components/BerryClubLanding';

function App() {
  return (
    <div className="App">
      <BerryClubLanding />
    </div>
  );
}

export default App;